/**
 * Acuerdos-Con-Gestores API
 * Acuerdos-Con-Gestores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactoModel } from './contactoModel';
import { DireccionModel } from './direccionModel';


export interface PoseedorReferenceModel { 
    id?: number;
    razonSocial?: string;
    tipoDocumento?: PoseedorReferenceModel.TipoDocumentoEnum;
    denominacionCentro?: string;
    codigoDocumento?: string;
    centro?: string;
    nima?: string;
    iban?: string;
    domicilios?: Array<DireccionModel>;
    contactos?: Array<ContactoModel>;
}
export namespace PoseedorReferenceModel {
    export type TipoDocumentoEnum = 'NIF' | 'DNI' | 'NIE';
    export const TipoDocumentoEnum = {
        Nif: 'NIF' as TipoDocumentoEnum,
        Dni: 'DNI' as TipoDocumentoEnum,
        Nie: 'NIE' as TipoDocumentoEnum
    };
}


